import { useEffect, useMemo, useRef, useState } from "react";
import { useBundle } from "@amzn/react-arb-tools";
import { LocalizedProps } from "./Localized";

/**
 * This is not for production builds, but for demonstrating the nature of React.Suspense
 * This is the same as Localized but w/a 2000ms delay where it is suspended.
 */
export const SlowLocalized: ({ id, namespace, args }: LocalizedProps) => React.ReactNode = ({
  id,
  namespace,
  args,
}: LocalizedProps) => {
  const [bundle, stringsLoading] = useBundle(namespace);
  const [waiting, setWaiting] = useState(true);
  const promise = useRef<Promise<void>>();
  useEffect(() => {
    if (stringsLoading && waiting) {
      promise.current = new Promise(() => {});
    }
    setTimeout(() => setWaiting(false), 2000);
  }, [stringsLoading, waiting]);
  if (promise.current && (waiting || stringsLoading)) {
    throw promise.current;
  }
  return <>{bundle?.formatMessage(id, args)}</>;
};
